import { memo } from 'react';
import { MediaPlaybackControlsProvider } from '../context/MediaPlaybackControlsContext';
import { MediaElementProvider } from '../context/MediaElementContext';
import { withMediaPlayerDefaults } from '../hoc/withMediaPlayerDefaults';
import { MediaPlaybackTimeContext } from '../context/MediaPlaybackTimeContext';
import { useAnimateControls } from '../hooks/_internal/useAnimateControls';
import { MediaPlaybackBufferProvider } from '../context/MediaPlaybackBufferContext';
import { jsx as _jsx } from "react/jsx-runtime";
const __InlineMediaPlayerProvider = withMediaPlayerDefaults(({
  children,
  engagementId,
  externalAccountId,
  mediaProgressBarRef,
  mediaRef,
  mediaState,
  mediaStateDispatch,
  source,
  src
}) => {
  useAnimateControls({
    mediaProgressBarRef,
    mediaRef,
    mediaState
  });
  return /*#__PURE__*/_jsx(MediaPlaybackControlsProvider, {
    clipEndTime: mediaState.clipEndTime,
    clipStartTime: mediaState.clipStartTime,
    containInClipTime: false,
    errorType: mediaState.errorType,
    initialClipStartTime: 0,
    mediaRef: mediaRef,
    mediaStateDispatch: mediaStateDispatch,
    preciseDuration: mediaState.preciseDuration,
    playbackRequested: mediaState.playbackRequested,
    roundedDuration: mediaState.roundedDuration,
    source: source,
    status: mediaState.status,
    children: /*#__PURE__*/_jsx(MediaElementProvider, {
      bufferStatus: mediaState.bufferStatus,
      engagementId: engagementId,
      externalAccountId: externalAccountId,
      maybeRequiresAuthUpdate: mediaState.maybeRequiresAuthUpdate,
      refetchedMediaUrl: mediaState.refetchedMediaUrl,
      mediaProgressBarRef: mediaProgressBarRef,
      mediaRef: mediaRef,
      mediaStateDispatch: mediaStateDispatch,
      recordingUrl: src,
      source: source,
      children: /*#__PURE__*/_jsx(MediaPlaybackTimeContext.Provider, {
        value: mediaState.currentTime,
        children: /*#__PURE__*/_jsx(MediaPlaybackBufferProvider, {
          bufferStatus: mediaState.bufferStatus,
          percentLoaded: mediaState.percentLoaded,
          mediaStateDispatch: mediaStateDispatch,
          children: children
        })
      })
    })
  });
});
export const InlineMediaPlayerProvider = /*#__PURE__*/memo(__InlineMediaPlayerProvider);